exports.getPermitObjects = (links, string) => {
    let perm = JSON.parse(links?.find((item) => item?.module_is_show === 1 && item?.module_path === string)?.permissions)
    // console.log(perm[0],'perm[0]');
    return perm[0];
}